/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LegacyMapCreateModel } from '../models/legacy-map-create-model';
import { LegacyMapCreateResult } from '../models/legacy-map-create-result';
import { LegacyMapGetModel } from '../models/legacy-map-get-model';
import { LegacyMapGetResult } from '../models/legacy-map-get-result';
import { LegacyMapListResult } from '../models/legacy-map-list-result';
import { LegacyMapRemoveModel } from '../models/legacy-map-remove-model';
import { LegacyMapRemoveResult } from '../models/legacy-map-remove-result';

@Injectable({
  providedIn: 'root',
})
export class LegacyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation v1LegacyProductsListGet
   */
  static readonly V1LegacyProductsListGetPath = '/v1/legacy-products/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1LegacyProductsListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1LegacyProductsListGet$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LegacyMapListResult>> {

    const rb = new RequestBuilder(this.rootUrl, LegacyService.V1LegacyProductsListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LegacyMapListResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1LegacyProductsListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1LegacyProductsListGet$Plain(params?: {
  },
  context?: HttpContext

): Observable<LegacyMapListResult> {

    return this.v1LegacyProductsListGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<LegacyMapListResult>) => r.body as LegacyMapListResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1LegacyProductsListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1LegacyProductsListGet$Json$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LegacyMapListResult>> {

    const rb = new RequestBuilder(this.rootUrl, LegacyService.V1LegacyProductsListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LegacyMapListResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1LegacyProductsListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1LegacyProductsListGet$Json(params?: {
  },
  context?: HttpContext

): Observable<LegacyMapListResult> {

    return this.v1LegacyProductsListGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<LegacyMapListResult>) => r.body as LegacyMapListResult)
    );
  }

  /**
   * Path part for operation v1LegacyProductsGetPost
   */
  static readonly V1LegacyProductsGetPostPath = '/v1/legacy-products/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1LegacyProductsGetPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsGetPost$Plain$Response(params?: {
    body?: LegacyMapGetModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LegacyMapGetResult>> {

    const rb = new RequestBuilder(this.rootUrl, LegacyService.V1LegacyProductsGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LegacyMapGetResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1LegacyProductsGetPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsGetPost$Plain(params?: {
    body?: LegacyMapGetModel
  },
  context?: HttpContext

): Observable<LegacyMapGetResult> {

    return this.v1LegacyProductsGetPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<LegacyMapGetResult>) => r.body as LegacyMapGetResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1LegacyProductsGetPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsGetPost$Json$Response(params?: {
    body?: LegacyMapGetModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LegacyMapGetResult>> {

    const rb = new RequestBuilder(this.rootUrl, LegacyService.V1LegacyProductsGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LegacyMapGetResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1LegacyProductsGetPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsGetPost$Json(params?: {
    body?: LegacyMapGetModel
  },
  context?: HttpContext

): Observable<LegacyMapGetResult> {

    return this.v1LegacyProductsGetPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<LegacyMapGetResult>) => r.body as LegacyMapGetResult)
    );
  }

  /**
   * Path part for operation v1LegacyProductsCreatePost
   */
  static readonly V1LegacyProductsCreatePostPath = '/v1/legacy-products/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1LegacyProductsCreatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsCreatePost$Plain$Response(params?: {
    body?: LegacyMapCreateModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LegacyMapCreateResult>> {

    const rb = new RequestBuilder(this.rootUrl, LegacyService.V1LegacyProductsCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LegacyMapCreateResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1LegacyProductsCreatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsCreatePost$Plain(params?: {
    body?: LegacyMapCreateModel
  },
  context?: HttpContext

): Observable<LegacyMapCreateResult> {

    return this.v1LegacyProductsCreatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<LegacyMapCreateResult>) => r.body as LegacyMapCreateResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1LegacyProductsCreatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsCreatePost$Json$Response(params?: {
    body?: LegacyMapCreateModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LegacyMapCreateResult>> {

    const rb = new RequestBuilder(this.rootUrl, LegacyService.V1LegacyProductsCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LegacyMapCreateResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1LegacyProductsCreatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsCreatePost$Json(params?: {
    body?: LegacyMapCreateModel
  },
  context?: HttpContext

): Observable<LegacyMapCreateResult> {

    return this.v1LegacyProductsCreatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<LegacyMapCreateResult>) => r.body as LegacyMapCreateResult)
    );
  }

  /**
   * Path part for operation v1LegacyProductsRemovePost
   */
  static readonly V1LegacyProductsRemovePostPath = '/v1/legacy-products/remove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1LegacyProductsRemovePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsRemovePost$Plain$Response(params?: {
    body?: LegacyMapRemoveModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LegacyMapRemoveResult>> {

    const rb = new RequestBuilder(this.rootUrl, LegacyService.V1LegacyProductsRemovePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LegacyMapRemoveResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1LegacyProductsRemovePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsRemovePost$Plain(params?: {
    body?: LegacyMapRemoveModel
  },
  context?: HttpContext

): Observable<LegacyMapRemoveResult> {

    return this.v1LegacyProductsRemovePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<LegacyMapRemoveResult>) => r.body as LegacyMapRemoveResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1LegacyProductsRemovePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsRemovePost$Json$Response(params?: {
    body?: LegacyMapRemoveModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LegacyMapRemoveResult>> {

    const rb = new RequestBuilder(this.rootUrl, LegacyService.V1LegacyProductsRemovePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LegacyMapRemoveResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1LegacyProductsRemovePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1LegacyProductsRemovePost$Json(params?: {
    body?: LegacyMapRemoveModel
  },
  context?: HttpContext

): Observable<LegacyMapRemoveResult> {

    return this.v1LegacyProductsRemovePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<LegacyMapRemoveResult>) => r.body as LegacyMapRemoveResult)
    );
  }

}
